import React from 'react';
import * as authHandler from "../utils/authHandler";
import * as routes from "../constants/routes";
import { history } from '../constants/common';

export default class Container extends React.Component {
    render() {
        if (!authHandler.isLoggedIn()) {
            history.push(routes.LOGIN);
        }

        return (
            <this.props.route.outlet />
        )
    }
}




// WEBPACK FOOTER //
// ./src/containers/Container.js